module.exports = __webpack_public_path__ + "img/recovery-password.5919c6d.webp";